import { Navigate, Outlet } from 'react-router-dom';
import { useIsAdmin } from '@/hooks/useAdmin';
import LoadingPage from '@/components/ui/LoadingPage';

/**
 * The clinical tools — segmentation, correction, export, treatment plan — as opposed to
 * the clinic dashboard behind {@link ClinicRoute}. A superadmin works cases, so it reaches
 * these from the console's case panel; a plain admin is a platform viewer and does not.
 */
export function ClinicWorkflowRoute() {
  const { isAdmin, isSuperAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return <LoadingPage />;
  }

  if (isAdmin && !isSuperAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}
